
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserProfile } from "@/types/auth";
import UserInfoCard from "./UserInfoCard";
import NavigationCards from "./NavigationCards";
import SettingsCards from "./SettingsCards";

interface ProfileTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  user: UserProfile | null;
  isLoading: boolean;
  updateProfile: (data: Partial<UserProfile>) => Promise<void>;
  signOut: () => Promise<void>;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({
  activeTab,
  setActiveTab,
  user,
  isLoading,
  updateProfile,
  signOut,
}) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab}>
      <TabsList className="grid grid-cols-2">
        <TabsTrigger value="profile">Profile</TabsTrigger>
        <TabsTrigger value="settings">Settings</TabsTrigger>
      </TabsList>

      <TabsContent value="profile" className="space-y-4">
        {/* User Info Card */}
        <UserInfoCard 
          user={user} 
          isLoading={isLoading} 
          updateProfile={updateProfile} 
        />
        
        {/* Navigation Cards */}
        <NavigationCards />
      </TabsContent>

      <TabsContent value="settings" className="space-y-4">
        <SettingsCards onSignOut={signOut} />
      </TabsContent>
    </Tabs>
  );
};

export default ProfileTabs;
